module.exports = __webpack_public_path__ + "static/media/bellBlack.e6800ec9.svg";